import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "showcase-app__filter" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["name", "id"]
const _hoisted_4 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: $options.filterName,
      class: "showcase-app__filter-label"
    }, [
      _renderSlot(_ctx.$slots, "filterTitle")
    ], 8 /* PROPS */, _hoisted_2),
    _withDirectives(_createElementVNode("select", {
      class: "custom-select",
      name: $options.filterName,
      id: $options.filterName,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedValue) = $event)),
      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.filterChange && $options.filterChange(...args)))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.filterOptions, (filterOption) => {
        return (_openBlock(), _createElementBlock("option", {
          value: filterOption.Key
        }, _toDisplayString(filterOption.Value), 9 /* TEXT, PROPS */, _hoisted_4))
      }), 256 /* UNKEYED_FRAGMENT */))
    ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_3), [
      [_vModelSelect, _ctx.selectedValue]
    ])
  ]))
}